import {
  selectActiveVirtualBackground,
  selectVirtualBackgroundStatus,
} from 'features/virtual-backgrounds/selectors';
import { SelectedVirtualBackground } from 'features/virtual-backgrounds/types';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { virtualBackgroundReset } from 'features/virtual-backgrounds/virtualBackgroundsSlice';
import { usePublishingFeed } from 'hooks/usePublishingFeed';
import { virtualBackgroundChangeRequested } from 'features/virtual-backgrounds/actions';
import VideoBackgroundTab from 'features/room/settings/tabs/VideoBackgroundTab';
import { useEffect } from 'react';
import { initVirtualBackground } from 'features/virtual-backgrounds/thunks/initVirtualBackground';

const VirtualBackground = () => {
  const dispatch = useAppDispatch();

  const { videoStream } = usePublishingFeed('media');

  const status = useAppSelector(selectVirtualBackgroundStatus);
  const selectedBackground = useAppSelector(selectActiveVirtualBackground);

  useEffect(() => {
    dispatch(initVirtualBackground());
  }, [dispatch]);

  const resetVB = () => {
    if (!selectedBackground.value) {
      return;
    }

    dispatch(virtualBackgroundReset());
  };

  const changeVB = (config: SelectedVirtualBackground) => {
    if (selectedBackground.value === config.value) {
      return;
    }

    dispatch(virtualBackgroundChangeRequested(config));
  };

  return (
    <VideoBackgroundTab
      error={status === 'error'}
      loading={status === 'initializing'}
      videoStream={videoStream}
      onChange={changeVB}
      onReset={resetVB}
      selected={selectedBackground.value}
    />
  );
};

export default VirtualBackground;
